import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { BaseUI } from '../../base.ui';
import { Country } from '../../../domain/data';
import { BaseClientInterface, DocumentType, GetCountriesUseCase } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-seven-admin-pbc',
    templateUrl: './full-data-seven-admin-pbc.component.html',
    styleUrls: ['./full-data-seven-admin-pbc.component.scss'],
})
export class FullDataSevenAdminPbcComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public DocumentType: typeof DocumentType = DocumentType;

    public prefix: string;
    public countries: Country[] = [];

    @Input()
    client: BaseClientInterface;

    @Input()
    number: number;

    constructor(parentEvents: ParentEvents, private dialog: MatDialog, private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `fdseven-${nextUniqueId++}-`;
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data as Country[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    resolveNumber(i: number): string {
        return `${this.number}.${(0.2 + i / 10).toFixed(1).substr(2)}`;
    }

    onResize(): void {
        this.parentEvents.resize();
    }
}
